import { useLocation } from "react-router-dom";
import { startHostedSignIn } from "../auth/cognito";
import { Btn } from "../components/Btn";

/**
 * Sign-in entry point. This page collects NO credentials — it hands off to the
 * Cognito Hosted UI (on …amazoncognito.com), which renders the email/password
 * form, Google button, sign-up, and forgot-password. Keeping the credential
 * form off ride4baker.org is a deliberate Safe Browsing measure (see
 * docs/safe-browsing.md).
 */
export function SignIn() {
  const loc = useLocation();
  const returnTo = (loc.state as { from?: string })?.from || "/";

  return (
    <div style={{ padding: "64px 22px 80px", display: "flex", justifyContent: "center" }}>
      <div style={{ maxWidth: 420, width: "100%", textAlign: "center" }}>
        <h1 style={{ margin: 0, fontFamily: "var(--display)", fontSize: 40, fontWeight: 400, letterSpacing: -1 }}>
          Sign in
        </h1>
        <p style={{ marginTop: 12, color: "var(--ink-soft)", lineHeight: 1.6 }}>
          You'll need an account to make or update a pledge. Continue to our secure sign-in
          page — sign in with email and password, continue with Google, or create a new account.
        </p>
        <Btn variant="primary" size="lg" full onClick={() => startHostedSignIn(returnTo)} style={{ marginTop: 24 }}>
          Continue to sign in
        </Btn>
        <p style={{ marginTop: 16, fontSize: 12.5, color: "var(--ink-soft)", lineHeight: 1.5 }}>
          Sign-in is handled on a secure Amazon Cognito page. Ride4Baker never sees or stores your password.
        </p>
      </div>
    </div>
  );
}
